<template>

    <div
      class="card p-3 mb-1"
      :class="{'box-loading': loading}">
      <div class="d-flex align-items-center">
        <div>
          {{ value.display_number }} ({{ value.brand }})
          <span v-if="value.default"><b> - Padrão</b></span>
        </div>
        <div class="mr-auto"></div>
        <button
          v-if="!value.default"
          class="btn btn-sm btn-primary mr-1"
          @click="setAsDefault(value.iugu_paymethod_id)">Definir como padrão</button>
        <button
          class="btn btn-sm btn-outline-secondary"
          @click="remove(value.iugu_paymethod_id)">Remover</button>
      </div>
    </div>

</template>

<script>
export default {
  name: 'BillingCredcardItem',
  components: {
  },
  props: {
    value: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    setAsDefault (id) {
      this.loading = true
      this.$store.dispatch('billingPaymethodsSetAsDefault', id).then(res => {
        this.loading = false
        this.$emit('changed')
      })
    },
    remove (id) {
      this.loading = true
      this.$store.dispatch('deleteBillingPaymethod', id).then(res => {
        this.loading = false
        this.$emit('removed')
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Billing/BillingCredcardItem.vue